import { gql, useMutation } from '@apollo/client';

import { GET_DATEV_NUMBER_BY_ID } from './get-datev-number-by-id.hook';
import { GET_DATEV_NUMBERS } from './get-datev-numbers.hook';

export const UPDATE_DATEV_NUMBER = gql`
  mutation updateDatevNumber($payload: UpdateDatevNumberInput!) {
    updateDatevNumber(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateDatevNumber = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateDatevNumber] = useMutation(UPDATE_DATEV_NUMBER, {
    onCompleted: onSuccess,
    refetchQueries: [GET_DATEV_NUMBER_BY_ID, GET_DATEV_NUMBERS],
  });

  return updateDatevNumber;
};
